module.exports = __webpack_public_path__ + "static/media/bank_logo.9c52a698.svg";